// src/App.js
import React from "react";
import ChatWidget from "./components/ChatWidget";
import logo from "./assets/logo.png"; // <-- PNG con sfondo bianco

const homeUrl = process.env.REACT_APP_HOME_URL || "/";

export default function App() {
  return (
    <div className="app">
      <header className="topbar">
          <div className="logo-box">
            <a href={homeUrl} className="logo-box" aria-label="Home">
                <img src={logo} alt="Logo" className="logo-img" />
            </a>
          </div>
      </header>
      <main className="chat">
        <ChatWidget />
      </main>
    </div>
  );
}